import { faCommentDots } from '@fortawesome/free-regular-svg-icons';
import { faLayerGroup, faEllipsisH } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AppBar from '@material-ui/core/AppBar';
import IconButton from '@material-ui/core/IconButton';
import Toolbar from '@material-ui/core/Toolbar';
import MuiMenu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import {
    setDrawerType,
    toggleChatComponent,
    toggleCollapsedNav,
} from 'actions/Setting';
import garmentLogoMini from 'assets/images/garment-logo-miniold.png';
import Menu from 'components/TopNav/Menu';
import {
    BELOW_THE_HEADER,
    FIXED_DRAWER,
    HORIZONTAL_NAVIGATION,
    INSIDE_THE_HEADER,
    MINI_DRAWER,
} from 'constants/ActionTypes';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { openLink } from '../../util/openLink';
import styles from './Header.module.scss';
import LanguageSwitcher from './LanguageSwitcher';
import isDirectionRTL from 'util/isDirectionRTL';
import Notifications from './Notifications/Notifications';
import { OfflineInlineInspections } from './OfflineInlineInspections';
import WhatThisTag from './WhatThisTag';
import QRCodeScannerButton from './QRCodeScannerButton';
import IntlMessages from 'util/IntlMessages';
class Header extends React.Component {
    constructor(props) {
        super(props);

        const pathname = props.location.pathname.split('/');
        this.state = {
            anchorEl: undefined,
            drawerType: props.drawerType,
            chatOpenned: props.chatOpenned,
            factory: pathname[1],
            moreMenuAnchorEl: null,
        };

        this.mq = window.matchMedia('(max-width : 768px)');
        
    }

    componentDidMount() {
        this.handleResize = () => {
            this.forceUpdate();
        };
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        if (this.handleResize) {
            window.removeEventListener('resize', this.handleResize);
        }
    }

    onToggleCollapsedNav = () => {
        const val = !this.props.navCollapsed;
        this.setState(
            (prevState) => {
                return {
                    drawerType:
                        prevState.drawerType === FIXED_DRAWER
                            ? MINI_DRAWER
                            : FIXED_DRAWER,
                };
            },
            () => {
                this.props.setDrawerType(this.state.drawerType);
                this.props.toggleCollapsedNav(val);
            },
        );
    };
    onToggleChat = () => {
        const val = !this.props.chatOpenned;
        this.props.toggleChatComponent(val);
    };

    handleMoreMenuClick = (event) => {
        this.setState({ moreMenuAnchorEl: event.currentTarget });
    };

    handleMoreMenuClose = () => {
        this.setState({ moreMenuAnchorEl: null });
    };

    render() {
        const {
            navigationStyle,
            horizontalNavPosition,
            showWipReport,
            sectionId,
            showOfflineInlineInspections,
            removeStickyHeader,
            IsWorkstation
        } = this.props;
        const { factory, moreMenuAnchorEl } = this.state;
        const shouldShowCompactHeader =
            this.mq.matches && (showOfflineInlineInspections || showWipReport || IsWorkstation);

        return (
            <AppBar
                className={`app-main-header ${
                    navigationStyle === HORIZONTAL_NAVIGATION &&
                    horizontalNavPosition === BELOW_THE_HEADER
                        ? 'app-main-header-top'
                        : ''
                } ${removeStickyHeader ? styles.nonStickyHeader : ''}`}
            >
                <Toolbar className='app-toolbar px-2' disableGutters={false}>
                    <IconButton
                        className={`jr-menu-icon mr-3 d-block ${styles.iconBtn}`}
                        aria-label='Menu'
                        onClick={this.onToggleCollapsedNav}
                    >
                        <span className={!this.mq.matches ? 'menu-icon' : ''}>
                            {this.mq.matches && (
                                <img
                                    src={garmentLogoMini}
                                    alt='Company Logo'
                                    width='40px'
                                    height='32px'
                                />
                            )}
                        </span>
                    </IconButton>

                    {this.props.children}

                    {navigationStyle === HORIZONTAL_NAVIGATION &&
                        horizontalNavPosition === INSIDE_THE_HEADER && <Menu />}

                    <div className='d-flex ml-auto align-items-center'>
                        <LanguageSwitcher />

                        {shouldShowCompactHeader ? (
                            <>
                                <Notifications />
                                <QRCodeScannerButton />
                                <WhatThisTag />
                                <IconButton
                                    className='p-2'
                                    size='small'
                                    onClick={this.handleMoreMenuClick}
                                >
                                    <FontAwesomeIcon
                                        icon={faEllipsisH}
                                        color='white'
                                    />
                                </IconButton>
                                <MuiMenu
                                    anchorEl={moreMenuAnchorEl}
                                    open={Boolean(moreMenuAnchorEl)}
                                    onClose={this.handleMoreMenuClose}
                                    className={styles.dropdownMenu}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'right',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                    getContentAnchorEl={null}
                                    PaperProps={{
                                        className: `${styles.dropdownMenuPaper} ${isDirectionRTL() ? styles.leftMneu : styles.rightMneu}`,
                                    }}
                                >
                                    {(showWipReport ||
                                        showOfflineInlineInspections) && (
                                        <p className={styles.dropdownMenuItem}>
                                            <IntlMessages id='shared.report.plural' />
                                        </p>
                                    )}
                                    {showWipReport && (
                                        <MenuItem
                                            onClick={() => {
                                                this.handleMoreMenuClose();
                                                openLink(
                                                    `/${factory}/wipReport?sectionId=${sectionId}`,
                                                    { ctrlKey: false },
                                                );
                                            }}
                                            className={styles.MenuItem}
                                        >
                                            <FontAwesomeIcon
                                                icon={faLayerGroup}
                                                color='#333'
                                                className={`${isDirectionRTL() ? styles.dropdownIconFaLeft : styles.dropdownIconFaRight}`}
                                              
                                            />
                                            <IntlMessages id='shared.WIPReport' />
                                        </MenuItem>
                                    )}
                                    {showOfflineInlineInspections && (
                                        <MenuItem
                                            onClick={this.handleMoreMenuClose}
                                            className={styles.MenuItem}
                                        >
                                            <div
                                                className={`${isDirectionRTL() ? styles.dropdownIconRight : styles.dropdownIconLeft}`}
                                            >
                                                <OfflineInlineInspections
                                                    shouldShowCompactHeader={
                                                        shouldShowCompactHeader
                                                    }
                                                />
                                            </div>
                                            <IntlMessages id='shared.offlineInspection' />
                                        </MenuItem>
                                    )}
                                    <p
                                        className={styles.dropdownMenuItem}
                                        style={{
                                            marginTop: '10px',
                                            marginBottom: '10px',
                                        }}
                                    >
                                        <IntlMessages id='shared.contactUs' />
                                    </p>
                                    <MenuItem
                                        onClick={() => {
                                            this.handleMoreMenuClose();
                                            this.onToggleChat();
                                        }}
                                    >
                                        <FontAwesomeIcon
                                            icon={faCommentDots}
                                            color='#333'
                                            className={`${isDirectionRTL() ? styles.dropdownIconFaLeft : styles.dropdownIconFaRight}`}
                                            />
                                        <IntlMessages id='shared.chat' />
                                    </MenuItem>
                                </MuiMenu>
                            </>
                        ) : (
                            <>
                                {showOfflineInlineInspections && (
                                    <OfflineInlineInspections />
                                )}
                                {showWipReport && (
                                    <IconButton
                                        id='wipReport'
                                        className='p-2'
                                        size='small'
                                    >
                                        <FontAwesomeIcon
                                            icon={faLayerGroup}
                                            color='white'
                                            onClick={() =>
                                                openLink(
                                                    `/${factory}/wipReport?sectionId=${sectionId}`,
                                                    { ctrlKey: false },
                                                )
                                            }
                                        />
                                    </IconButton>
                                )}

                                <Notifications />
                                <QRCodeScannerButton />
                                <WhatThisTag />

                                <IconButton
                                    id='customIntercom'
                                    className='p-2'
                                    size='small'
                                    onClick={this.onToggleChat}
                                >
                                    <FontAwesomeIcon
                                        icon={faCommentDots}
                                        color='white'
                                    />
                                </IconButton>
                            </>
                        )}
                    </div>
                </Toolbar>
            </AppBar>
        );
    }
}

const mapStateToProps = ({ settings, notifications }) => {
    const {
        drawerType,
        locale,
        navigationStyle,
        horizontalNavPosition,
        chatOpenned,
    } = settings;
    const { userNotifications } = notifications;
    return {
        drawerType,
        locale,
        navigationStyle,
        horizontalNavPosition,
        userNotifications,
        chatOpenned,
    };
};

export default withRouter(
    connect(mapStateToProps, {
        toggleCollapsedNav,
        toggleChatComponent,
        setDrawerType,
    })(Header),
);
